import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const StoreListTopContent = (_param)=> {
    var { title , description , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "title",
        "description",
        "className"
    ]);
    return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-list-top-content-stores-v2', className)
    }), title && /*#__PURE__*/ React.createElement("h1", {
        className: "h3"
    }, title), description && /*#__PURE__*/ React.createElement("p", {
        "data-t": "store-list-top-content-description"
    }, description));
};

export { StoreListTopContent as default };
//# sourceMappingURL=StoreListTopContent.js.map
